import React, {forwardRef, useRef, useState} from 'react';

import Header from '@Themes/natucare/modules/Header/Header';

import {transformContentData} from './utils/transformContentData';
import {transformProductsData} from './utils/transformProductsData';

import {getSearchResults} from './api/getSearchResults';
import {saveSearch} from './api/saveSearch';

const initialState = {
  status: {
    isFetching: false,
    isLoaded: true
  }
};

const HeaderApi = forwardRef(({headerData, isBlogPostTemplate}, readingIndicatorRef) => {
  const [searchResults, setSearchResults] = useState(initialState);

  const [searchPhrase, setSearchPhrase] = useState('');

  const lastSearchTermRef = useRef(null);

  const handleSearch = async e => {
    const searchTerm = e.trim();

    setSearchPhrase(searchTerm);

    if (searchTerm === lastSearchTermRef.current) {
      return;
    }

    lastSearchTermRef.current = searchTerm;

    setSearchResults({
      status: {
        isFetching: true,
        isLoaded: false
      }
    });

    const {shopifyProducts, blogPosts, blogLists} = await getSearchResults(searchTerm);

    const newProductsItems = transformProductsData(shopifyProducts);
    const newContentItems = transformContentData(blogPosts, blogLists);

    setSearchResults({
      status: {
        isFetching: false,
        isLoaded: true
      },
      notFoundDescription: 'Przykro nam ale nie znaleźliśmy nic pod hasłem',
      stringNotFound: (newProductsItems.length === 0 && newContentItems.length === 0) ? searchTerm : undefined,
      ...(newProductsItems.length > 0 && {
        products: {
          title: 'Sklep',
          items: newProductsItems,
          button: {
            label: 'zobacz wszystkie produkty',
            href: 'https://shop.natu.care/collections/all'
          }
        }
      }),
      ...(newContentItems.length > 0 && {
        content: [
          {
            title: 'Baza wiedzy',
            items: newContentItems
          }
        ]
      })
    });
  };

  const hasActiveSearch = searchResults !== initialState;
  // const resultsToDisplay = hasActiveSearch ? searchResults : {...initialState, ...headerData.searchResults};
  const resultsToDisplay = hasActiveSearch ? searchResults : {...initialState};

  return <Header {...headerData} ref={readingIndicatorRef} isBlogPostTemplate={isBlogPostTemplate}
                 searchResults={resultsToDisplay} searchTerm={searchPhrase} sendSearchData={saveSearch}
                 onChange={handleSearch}/>;
});

export default HeaderApi;
